import { a as c } from "./chunk-BaseElement-CJM6sCUz.js";
import { p as i } from "./chunk-productCompareStorage-CP1RJJhy.js";
import { t as n } from "./chunk-custom-element-CN0MC8o7.js";
import { n as s } from "./chunk-property---aaewZr.js";
var h = Object.defineProperty, m = Object.getOwnPropertyDescriptor, o = (t, e, u, d) => {
  for (var r = d > 1 ? void 0 : d ? m(e, u) : e, l = t.length - 1, p; l >= 0; l--)
    (p = t[l]) && (r = (d ? p(e, u, r) : p(r)) || r);
  return d && r && h(e, u, r), r;
};
let a = class extends c {
  connectedCallback() {
    super.connectedCallback(), this.init();
  }
  isCompareActive() {
    return i.hasAny();
  }
  isCompareFull() {
    return i.isFull();
  }
  isAdded() {
    return i.get().includes(this.productHandle);
  }
  init() {
    var t;
    this.productHandle && this.dataset.init != "true" && document.querySelector("product-compare") && (this.dataset.init = "true", this.updateButton(), window.addEventListener("storage", () => {
      this.updateButton();
    }), (t = this.querySelector("button")) == null || t.addEventListener("click", () => {
      this.isAdded() ? i.remove(this.productHandle) : this.compareFull || i.add(this.productHandle);
    }));
  }
  updateButton() {
    var t, e;
    this.isAdded() ? this.added = !0 : this.added = !1, this.compareActive = this.isCompareActive(), this.compareFull = this.isCompareFull(), this.compareFull && !this.added ? (t = this.querySelector("button")) == null || t.setAttribute("aria-disabled", "true") : (e = this.querySelector("button")) == null || e.removeAttribute("aria-disabled");
  }
};
o([
  s({ type: String, attribute: "product-handle" })
], a.prototype, "productHandle", 2);
o([
  s({ type: Boolean, attribute: "data-added", reflect: !0 })
], a.prototype, "added", 2);
o([
  s({ type: Boolean, attribute: "data-compare-active", reflect: !0 })
], a.prototype, "compareActive", 2);
o([
  s({ type: Boolean, attribute: "data-compare-full", reflect: !0 })
], a.prototype, "compareFull", 2);
a = o([
  n("track-product-compare")
], a);
export {
  a as TrackProductCompare
};
